import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectCostIT } from "../Model/ProposalProjectCostIT";


export async function patchProposalProjectCostIT(data) {	
	let response = await getAPIResponse("/v1/proposal-project-cost-it", data, "PATCH");
	if (response === null) {
		return null;
	}
	let proposalProjectCostIT = [];
	response.forEach((responseData) => {
		proposalProjectCostIT.push(ProposalProjectCostIT.createFromResponseData(responseData));
	});
	return proposalProjectCostIT;
}